// extracted by mini-css-extract-plugin
module.exports = {"container":"LatestBlock_container_2yuwp","topContainer":"LatestBlock_topContainer_1z-dR","topInfo":"LatestBlock_topInfo_1ectA","notExist":"LatestBlock_notExist_3hkyY"};